import React, { FC, useContext } from 'react'
import Typography from '@mui/material/Typography'
import Button from '@mui/material/Button'
import List from '@mui/material/List'
import ListItem from '@mui/material/ListItem'
import ListItemText from '@mui/material/ListItemText'
import Box from '@mui/material/Box'

import BookingContext from '../../contexts/booking'

import {
  getProductTitle,
  getDateTimeString,
} from '@kaidam/fc-shared/src/booking/utils'

import {
  getTitle as getPriceTitle,
} from '@kaidam/fc-shared/src/utils/price'

const BookingSummary: FC<React.PropsWithChildren<{
  overrideTitle: string,
}>> = ({
  overrideTitle = '',
}) => {
  const booking = useContext(BookingContext)

  return (
    <>
      {
        overrideTitle && (
          <Typography
            color="primary"
            align="left"
            gutterBottom
            variant="h6"
          >
            { overrideTitle }
          </Typography>
        )
      }
      {
        booking.org && (
          <Typography
            color={ overrideTitle ? 'textPrimary' : 'primary' }
            align="left"
            gutterBottom
            variant={ overrideTitle ? 'body1' : 'h6' }
          >
            { booking.org.profile.name }
            { booking.data.details ? ` : ${booking.data.details.postcode}` : '' }
          </Typography>
        )
      }
      {
        booking.postcode && (
          <Typography
            color="primary"
            align="left"
            gutterBottom
            variant="subtitle1"
          >
            { booking.postcode.toUpperCase() }
          </Typography>
        )
      }
      {
        booking.data.date && (
          <List sx={{ p: 0 }}>
            <ListItem sx={{ p: 0 }}>
              <ListItemText
                primary={ new Date(booking.data.date).toLocaleString() } 
                secondary={ booking.data.details ? booking.data.details.email : '' }
              />
            </ListItem>
          </List>
        )
      }
      {
        booking.data.product && (
          <List sx={{ p: 0 }}>
            <ListItem sx={{ p: 0 }}>
              <ListItemText
                primary={ booking.data.product.name } 
                secondary={ getPriceTitle(booking.data.product.price * 100) }
              />
            </ListItem>
            <ListItemText
              secondary={ booking.data.product.comment }
            />
          </List>
        )
      }
      {
        booking.pageName != 'payment_confirm' && (
          <Box sx={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center'
          }}>
            <Box sx={{ flexGrow: 1 }}>
              {
                booking.pageIndex > 0 && (
                  <Button
                    size="small"
                    variant="outlined"
                    color="primary"
                    sx={{ my: 1, mr: 1 }}
                    disabled={ booking.loading }
                    onClick={ () => booking.openPage(-1) }
                  >
                    Back
                  </Button>
                )
              }
              {
                booking.pageScore > booking.pageIndex && (
                  <Button
                    size="small"
                    variant="outlined"
                    color="primary"
                    sx={{ my: 1, mr: 1 }}
                    disabled={ booking.loading }
                    onClick={ () => booking.openPage(1) }
                  >
                    Next
                  </Button>
                )
              }
            </Box>
            <Box sx={{ flexGrow: 0 }}>
              <Button
                size="small"
                variant="outlined"
                color="primary"
                sx={{ my: 1, mr: 1 }}
                disabled={ booking.loading }
                onClick={ () => booking.restart() }
              >
                Restart
              </Button>
            </Box>
          </Box>
        )
      }
    </>
  )
}

export default BookingSummary